<template functional>
	<el-submenu :index="props.data.id.toString()" :title="props.data.title">
		<template slot="title">
			<i :class="props.data.icon"></i>
			<span class="overtitleOne lin-h50">{{props.data.title}}</span>
		</template>
		<template v-for="item in props.data.children">
			<el-menu-item class="subitem" :index="item.id.toString()" v-if="item.childids===0" :title="item.title">
				<i :class="item.icon"></i>
				<span slot="title" class="overtitleOne lin-h50">{{item.title}}</span>
			</el-menu-item>
			<sub-menu v-else :data="item" :key="item.id"></sub-menu>
		</template>
	</el-submenu>
	
</template>
<script>
	export default {
		name: "submenu",
		props: {
			data: [Array, Object]
		},
		data() {
			return {};
		},
		mounted() {},
		methods: {
			handClick(topid,pid){
				// console.log(topid,pid)
			},
		}
	};
</script>

<style>
	.typeselect {
		background-color: #CCCCCC !important;
	}
	.lin-h50{
		height: 50px;
		line-height: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu.vue